/*--------------------------------------------------------------
>>> TABLE OF CONTENTS:
----------------------------------------------------------------
1.0 - Globals
2.0 - Blocks
3.0 - Block - Hero Media
--------------------------------------------------------------*/


// 1.0 - Globals
const $ = require('jquery');


// 2.0 - Blocks
export function blocks() {
 
    (function(){
	
	    const sliderHeroFeatured = function() { 
            $('.js-hero-featured').not('.slick-initialized').slick({
                rows: 0,
                dots: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 7000,
                pauseOnHover: true,
                appendDots: $('.utilities-hero'), // Move dots to .utilities
                appendArrows: $('.utilities-hero'), // Move arrows to .utilities
            });     
        }

	    const sliderGalleryTwo = function() { 
            $('.js-gallery-two').not('.slick-initialized').slick({
                rows: 0,
                dots: true,
                arrows: true,
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
			        {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                        }
                    }
			   ]
            });     
        }
	    
        const sliderGalleryThree = function() { 
            $('.js-gallery-three').not('.slick-initialized').slick({
                rows: 0,
                dots: true,
                arrows: true,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
			        {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                        }
                    }
			   ]
            });     
        }

	    const sliderThree = function() { 
            const sliders = document.querySelectorAll('.js-slider-3');
            
            if(sliders) {
                sliders.forEach(slider => {
                    let utilities = slider.nextElementSibling;
                    while (utilities && !utilities.classList.contains('utilities')) {
                        utilities = utilities.nextElementSibling;
                    }
                    
                    $(slider).not('.slick-initialized').slick({
                        rows: 0,
                        dots: true,
                        arrows: true,
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        appendDots: utilities, // Move dots to the nearest .utilities
                        appendArrows: utilities, // Move arrows to the nearest .utilities
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: true,
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    }); 
                });
            }
        }	
	    
        const sliderTwo = function() { 
            const sliders = document.querySelectorAll('.js-slider-2');
            
            if(sliders) {
                sliders.forEach(slider => {
                    let utilities = slider.nextElementSibling;
                    while (utilities && !utilities.classList.contains('utilities')) {
                        utilities = utilities.nextElementSibling;
                    }
                    
                    $(slider).not('.slick-initialized').slick({
                        rows: 0,
                        dots: true,
                        arrows: true,
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        appendDots: utilities, // Move dots to the nearest .utilities
                        appendArrows: utilities, // Move arrows to the nearest .utilities
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: true,
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    }); 
                });
            }
        }	
	    const sliderOne = function() { 
            const sliders = document.querySelectorAll('.js-slider-1');
            
            if(sliders) {
                sliders.forEach(slider => {
                    let utilities = slider.nextElementSibling;
                    while (utilities && !utilities.classList.contains('utilities')) {
                        utilities = utilities.nextElementSibling;
                    }
                    
                    $(slider).not('.slick-initialized').slick({
                        rows: 0,
                        dots: true,
                        arrows: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        appendDots: utilities, // Move dots to the nearest .utilities
                        appendArrows: utilities, // Move arrows to the nearest .utilities
                    }); 
                });
            }
        }	
	
	    // Initialize each block on page load (front end).
	    $(document).ready(function(){
            sliderThree();
            sliderTwo();
            sliderOne();
            sliderGalleryTwo();
            sliderGalleryThree();
            sliderHeroFeatured();
	    });
	
	    // Initialize dynamic block preview (editor).
	    if( window.acf ) {
	        window.acf.addAction( 'render_block_preview/type=grid-cards', sliderThree );
	        window.acf.addAction( 'render_block_preview/type=grid-cards', sliderTwo );
	        window.acf.addAction( 'render_block_preview/type=related-content', sliderThree );
	        window.acf.addAction( 'render_block_preview/type=slider-media', sliderOne );
	        window.acf.addAction( 'render_block_preview/type=gallery', sliderGalleryTwo );
	        window.acf.addAction( 'render_block_preview/type=grid-cards', sliderGalleryTwo );
	        window.acf.addAction( 'render_block_preview/type=gallery', sliderGalleryThree );
	        window.acf.addAction( 'render_block_preview/type=hero', sliderHeroFeatured ); 
	    }
	
    })(jQuery);
    
}


// 3.0 - Block - Hero Media
export function heroMedia() {
    const heroParent = document.querySelectorAll('.js-hero-media');

    if (heroParent) {
        heroParent.forEach(function(hero) {
            const profile = hero.querySelector('.js-hero-media__profile');
            const content = hero.querySelector('.js-hero-media__main');

            if (profile && content) {
                const profileHeight = profile.clientHeight;
                const paddingTop = window.getComputedStyle(content, null).getPropertyValue('padding-top');
                
                hero.style.minHeight = profileHeight + parseInt(paddingTop, 10) + 'px';
            }
        });
    }
}

function handleResize() {
    const heroParent = document.querySelectorAll('.js-hero-media');

    if(heroParent) {
        if (window.innerWidth > 768) {
            heroMedia();
        } else {
            heroParent.forEach(function(hero) {
                hero.style.minHeight = '';
            });
        }    
    }
    
}

// Initial call
handleResize();

// Add event listener for window resize
// eslint-disable-next-line
window.addEventListener('resize', handleResize);